/**
 * Created by zsp on 2018/6/04.
 */

import axios from 'axios'
import { getToken } from '@/utils/cookie'

const service = param => {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Token': getToken()
    }
  }
  return axios[param.method](param.url, param.data, config).then(response => {
    const res = response.data
    return res
  }).catch(error => {
    return Promise.reject(error)
  })
}

export default service



// WEBPACK FOOTER //
// ./src/utils/uploads.js